import { useContext } from 'react';
import { AuthContextDispatch, AuthContextState } from './context';

export const useAuthStateContext = () => {
    const context = useContext(AuthContextState);

    if(!context) {
        throw Error('useAuthStateContext must be used inside an AuthContextProvider')
    }
    
    return context
};

export const useAuthDispatchContext = () => {
    const context = useContext(AuthContextDispatch);

    if(!context) {
        throw Error('useAuthDispatchContext must be used inside an AuthContextProvider')
    }
    
    return context
};